<template lang="pug">
  v-layout(align-start)
    v-flex
      v-card.pa-2(width='100vw' outlined color='grey_1')
        v-app-bar(dark color='primary')
          v-toolbar-title.headline LISTADO DE PRODUCTOS
        v-card-text(style='padding: 0px 16px 8px 16px;')
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black; padding: 16px 16px 0px 16px;') Almacen
                v-card-text(style='padding: 16px 16px 0px 16px;')
                  v-row(dense)
                    v-flex(xs12 sm6 md7)
                      v-autocomplete( autocomplete="off" v-model='almacenSelec' dense outlined placeholder="Seleccione" :items="almacenes" @change="almacenSeleccionado")
                    v-flex(xs12 sm6 md3)
                      v-btn.imprimir(color='primary' dense dark @click='imprimirPDF')
                        v-icon mdi-pdf-box
                        | IMPRIMIR LISTADO
                    v-flex(xs12 sm6 md2)
                      v-tooltip(bottom)
                        template(v-slot:activator='{ on }')
                          v-checkbox.shrink.mr-2.mt-0(v-model='checkbox' v-on="on" color='success' dense label='Stock Actual')
                            | MARQUE LA CASILLA SOLO PARA IMPRIMIR EL STOCK ACTUAL
            v-col(cols='12')
              v-card(color='white')
                v-card-text
                  v-row(dense)
                    v-col(cols='12' sm='12' md='12' )
                      v-data-table.elevation-4(:headers='headers' dense item-key='productos' :items='productos' :items-per-page='page' :page.sync='sync' :loading='loading' loading-text='Cargando, por favor espere...')
                        template(v-slot:no-data)
                          h2 No hay productos en este almacen
</template>

<script>
import Api from '@/services/methods'
import printJS from 'print-js'
export default {
  name: 'ListadoProducto',
  data: () => ({
    stock: [],
    nombreAlmacen: '',
    checkbox: false,
    loading: false,
    dialog: false,
    editedIndex: -1,
    almacenes: [],
    almacenSelec: null,
    almacenesTransferir: [],
    productos: [],
    productos2: [],
    page: 10,
    sync: 1,
    pagination: {},
    headers: [
      { text: 'Codigo', align: 'left', sortable: false, value: 'idProducto.nombre' },
      { text: 'Nombre', align: 'center', value: 'idProducto.descripcion' },
      { text: 'Stock', align: 'center', value: 'cantidad' },
      { text: 'IVA', align: 'center', value: 'idIva.descripcion' },
      { text: 'Costo(Bs)', align: 'center', value: 'costo' },
      { text: 'Precio(Bs)', align: 'center', value: 'precioBs' },
      { text: 'Precio($)', align: 'center', value: 'precio' }
    ]
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.nombreAlmacen = ''
      this.listarAlmacenes()
    },
    // imprimirPDF () {
    //   printJS({
    //     printable: 'listp',
    //     type: 'html',
    //     targetStyles: ['*']
    //   })
    // },
    imprimirPDF () {
      if (this.checkbox) {
        // Imprime > 0
        this.stock = []
        this.stock = this.productos2
      } else {
        // Imprime todo
        this.stock = [] 
        this.stock = this.productos
      }
      
      this.stock.sort(function (a, b) {
        if (a.idProducto.descripcion.toLowerCase() > b.idProducto.descripcion.toLowerCase()) {
          return 1;
        }
        if (a.idProducto.descripcion.toLowerCase() < b.idProducto.descripcion.toLowerCase()) {
          return -1;
        }
        return 0;
      });

      printJS({
        printable: this.stock,
        type: 'json',
        properties: [
          { field: 'idProducto.nombre', displayName: 'Codigo' },
          { field: 'idProducto.descripcion', displayName: 'Nombre' },
          { field: 'cantidad', displayName: 'Stock' },
          { field: 'idIva.descripcion', displayName: 'IVA' },
          { field: 'costo', displayName: 'Costo(Bs)' },
          { field: 'precioBs', displayName: 'Precio(Bs)' },
          { field: 'precio', displayName: 'Precio($)' }
        ],
        header: 'Listado de Productos en Almacen ' + this.nombreAlmacen,
        style: 'td { text-align: center; }',
        targetStyles: ['*']
      })
    },
    almacenSeleccionado (data) {
      const almaselec = this.almacenes.find(almaselec => almaselec.value === data)
      this.nombreAlmacen = almaselec.text
      this.loading = true
      this.productos = []
      const pos = this.almacenes.findIndex(almacen => almacen.value === data)
      this.almacenesTransferir = [...this.almacenes]
      this.almacenesTransferir.splice(pos, 1)
      this.listarProductos(data)
    },
    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          response.data.map(almacen => {
            this.almacenes.push({
              value: almacen._id,
              text: almacen.descripcion
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    listarProductos (idAlmacen) {
      Api.get('proalma/almacen/' + idAlmacen)
        .then(response => {
          this.loading = false
          this.productos = response.data
          this.productos2 = []
          for (let i = 0; i < this.productos.length; i++) {
            if (this.productos[i].cantidad > 0) {
              this.productos2.push(this.productos[i])
            }
          }
          this.productos.map(producto => {
            producto.costo = this.formatoDecimal(producto.costo);
            producto.precio = this.formatoDecimal(producto.precio);
            producto.precioBs = this.formatoDecimal(producto.precioBs)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    formatoDecimal (i) {
      let n = parseFloat(i).toFixed(2)
      return Number(n).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  }
}
</script>

<style lang="scss">
.imprimir {
  position: absolute;
  margin-left: 5%;
}
</style>
